export default {
    ADMIN: "管理員",
    CEO: "執行長",
    HEAD: "部門主任",
    INVESTIGATOR: "調查員"
}